module.exports = __webpack_public_path__ + "img/nomsg_icon.60499ce3.svg";